import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import {
  GetSinglePosition,
  SelectSinglePosition,
  SelectSinglePositionLoadingStatus,
} from "../state/reducers/PositionReducer";
import {
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider,
  Paper,
} from "@mui/material";
import PlayerCard from "../components/Cards/PlayerCard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  GridColDef,
  GridCellParams,
  GridRowParams,
  GridEvents,
  MuiEvent,
  GridCallbackDetails,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import { CalculatePlayerStats } from "../globals/Functions";
import { PlayerStats, Player, Game } from "../types/types";
import PlayerDataGrid from "../components/DataGrid/PlayerDataGrid";
import AddIcon from "@mui/icons-material/Add";
import { AddPlayer } from "../state/reducers/ChosenPlayersReducer";
import PlayerCardsContainer from "../components/Carousel/PlayerCardsContainer";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import { MyContainer, TeamLogos, TeamsList } from "../globals/Globals";
import Loading from "../components/Loading";
//import { RegisterPageView } from '../functions/Analytics';
import AdsenseAdd from "../components/AdsenseAdd";
import { RoomPreferences } from "@mui/icons-material";
import { PageContainer } from "../globals/styles";
import Header from "../components/Header/Header";
import { useNavigate, useParams } from "react-router-dom";
import { RegisterPageView } from "../globals/Analytics";
import FeaturePlayerCard from "../components/Cards/FeaturePlayerCard";
import CarouselContainer from "../components/Carousel/CarouselContainer";
import SportsCricketIcon from "@mui/icons-material/SportsCricket";
import SportsHandballIcon from "@mui/icons-material/SportsHandball";
import PanToolIcon from "@mui/icons-material/PanTool";
import RoundedCTA from "../components/CTAs/RoundedCTA";
import MyTransition from "../components/Theming/MyTransition";
import SinglePositionTable from "../components/SinglePosition/CardTableSwitch";
import SinglePositionPlayers from "../components/SinglePosition/SinglePositionPlayers";
import { CURRENT_SEASON } from "../globals/BBLData";

const columns: GridColDef[] = [
  { field: "name", headerName: "Name", width: 180 },
  {
    field: "team",
    headerName: "Team",
    width: 190,
    renderCell: (params: GridRenderCellParams<Date>) => (
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "38px",
          alignItems: "center",
          background: `linear-gradient(120deg, ${params.row.teamcolors[0]} 0%, ${params.row.teamcolors[0]} 50%, ${params.row.teamcolors[1]} 50%)`,
          color: "white",
        }}
      >
        <img
          style={{ height: "1.5rem", width: "2rem" }}
          src={params.row.teamlogo}
          alt="Team logo"
        />
        <p>{params.row.teamname}</p>
      </div>
    ),
  },
  {
    field: "price",
    headerName: "Price",
    width: 180,
    renderCell: (params: GridRenderCellParams<Date>) => (
      <div style={{ width: "100%", justifyContent: "center", display: "flex" }}>
        <span>
          {params.row.price.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        </span>
        <span style={{ color: params.row.pricechange > -1 ? "green" : "red" }}>
          &nbsp;
          {params.row.pricechange
            ? `(${params.row.pricechange?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })})`
            : ""}
        </span>
      </div>
    ),
  },

  { field: "scbe", headerName: "BE", type: "number" },
  { field: "avgpts", headerName: "Avg Pts", type: "number" },
  { field: "batSR", headerName: "BAT SR", type: "number" },
  { field: "bwlSR", headerName: "BWL SR", type: "number" },
  { field: "three", headerName: "3rd Avg", type: "number" },
  { field: "five", headerName: "5rd Avg", type: "number" },
  {
    field: "addbutton",
    headerName: "",
    renderCell: (params: GridRenderCellParams<Date>) => <AddIcon />,
  },
  //{ field: 'threeFive', headerName: '3/5 rd' , type: "number"},
];

const BatColumns: GridColDef[] = [
  { field: "name", headerName: "Name", width: 180 },
  {
    field: "team",
    headerName: "Team",
    width: 190,
    renderCell: (params: GridRenderCellParams<Date>) => (
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "38px",
          alignItems: "center",
          background: `linear-gradient(120deg, ${params.row.teamcolors[0]} 0%, ${params.row.teamcolors[0]} 50%, ${params.row.teamcolors[1]} 50%)`,
          color: "white",
        }}
      >
        <img
          style={{ height: "1.5rem", width: "2rem" }}
          src={params.row.teamlogo}
          alt="Team logo"
        />
        <p>{params.row.teamname}</p>
      </div>
    ),
  },
  {
    field: "price",
    headerName: "Price",
    width: 180,
    renderCell: (params: GridRenderCellParams<Date>) => (
      <div style={{ width: "100%", justifyContent: "center", display: "flex" }}>
        <span>
          {params.row.price.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        </span>
        <span style={{ color: params.row.pricechange > -1 ? "green" : "red" }}>
          &nbsp;
          {params.row.pricechange
            ? `(${params.row.pricechange?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })})`
            : ""}
        </span>
      </div>
    ),
  },
  { field: "scbe", headerName: "BE", type: "number" },
  { field: "batSR", headerName: "BAT SR", type: "number" },
  { field: "battingStyles", headerName: "Batting Style", width: 150 },
  { field: "three", headerName: "3rd Avg", type: "number" },
  { field: "five", headerName: "5rd Avg", type: "number" },
  {
    field: "addbutton",
    headerName: "",
    renderCell: (params: GridRenderCellParams<Date>) => <AddIcon />,
  },
  //{ field: 'threeFive', headerName: '3/5 rd' , type: "number"},
];

const BwlColumns: GridColDef[] = [
  { field: "name", headerName: "Name", width: 180 },
  {
    field: "team",
    headerName: "Team",
    width: 190,
    renderCell: (params: GridRenderCellParams<Date>) => (
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "38px",
          alignItems: "center",
          background: `linear-gradient(120deg, ${params.row.teamcolors[0]} 0%, ${params.row.teamcolors[0]} 50%, ${params.row.teamcolors[1]} 50%)`,
          color: "white",
        }}
      >
        <img
          style={{ height: "1.5rem", width: "2rem" }}
          src={params.row.teamlogo}
          alt="Team logo"
        />
        <p>{params.row.teamname}</p>
      </div>
    ),
  },
  {
    field: "price",
    headerName: "Price",
    width: 180,
    renderCell: (params: GridRenderCellParams<Date>) => (
      <div style={{ width: "100%", justifyContent: "center", display: "flex" }}>
        <span>
          {params.row.price.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        </span>
        <span style={{ color: params.row.pricechange > -1 ? "green" : "red" }}>
          &nbsp;
          {params.row.pricechange
            ? `(${params.row.pricechange?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })})`
            : ""}
        </span>
      </div>
    ),
  },

  { field: "scbe", headerName: "BE", type: "number" },
  { field: "bwlSR", headerName: "BWL SR", type: "number" },
  { field: "bowlingStyles", headerName: "Bowling Style", width: 150 },
  { field: "three", headerName: "3rd Avg", type: "number" },
  { field: "five", headerName: "5rd Avg", type: "number" },
  {
    field: "addbutton",
    headerName: "",
    renderCell: (params: GridRenderCellParams<Date>) => <AddIcon />,
  },
  //{ field: 'threeFive', headerName: '3/5 rd' , type: "number"},
];

interface rowclickparam {
  grid: GridRowParams;
}

const PositionStrings = {
  BAT: "Batters",
  BWL: "Bowlers",
  WKP: "Wicket Keepers",
};

let PositonsArray = [
  { position: "BAT", icon: SportsCricketIcon },
  { position: "BWL", icon: SportsHandballIcon },
  { position: "WKP", icon: PanToolIcon },
];

const SinglePosition = () => {
  let router = useNavigate();
  const [done, setDone] = useState(false);
  const dispatch = useAppDispatch();
  let { name } = useParams<{ name: string }>();
  const [animate, setAnimate] = useState(false);
  useEffect(() => {
    dispatch(GetSinglePosition(name));
    RegisterPageView({ path: `/position/${name}` });
  }, [name]);

  let thePosition = useAppSelector(SelectSinglePosition);
  let isloading = useAppSelector(SelectSinglePositionLoadingStatus);
  console.log("thePosition: ", thePosition);
  let selectedColumns = columns;
  if (name === "BAT") {
    selectedColumns = BatColumns;
  } else if (name === "BWL") {
    selectedColumns = BatColumns;
  }
  let positionname = thePosition["position"]["name"];
  let players = thePosition["players"];
  let featuredPlayers = thePosition["featuredPlayers"];
  const [rows, setRows] = useState<object[]>([]);
  //let singleposition = useAppSelector(SelectSinglePosition);
  //let players = singleposition?.players;

  useEffect(() => {
    PopulateRows();
    //RegisterPageView({path: `/position/${name}`});
  }, [positionname]);
  useEffect(() => {}, [isloading]);
  setTimeout(() => {
    if (!isloading === "loading") {
      setAnimate(true);
    }
  }, 500);

  const onCellClick = (
    params: GridCellParams,
    event: MuiEvent<React.MouseEvent>,
    details: GridCallbackDetails
  ) => {
    if (params.field !== "addbutton") {
      router("/player/" + params.row.id);
    } else {
      let player: Player = {
        id: "",
        firstname: "",
        lastname: "",
        pic: "",
        position: { name: "" },
        positions: [],
        stats: [
          { last5Games: [], timestamp: "", avgpts: 0, avgbase: 0, ppm: 0 },
        ],
        positionrank: [],
        ownerships: [],
      };
      players.map(function (p) {
        if (p.id === params.row.id) {
          player = p;
        }
      });
      dispatch(AddPlayer(player));
    }
  };

  const onRowClick = (grid: GridRowParams) => {
    router("/player/" + grid.row.id);
    return 1;
  };
  const PopulateRows = () => {
    var newrows: object[] = [];

    players.map(function (player) {
      if (player) {
        if (player.stats[0]?.lastgame) {
          var playerstats = CalculatePlayerStats({
            games: [player.stats[0].lastgame],
          });
          let thestat = player.stats[0];
          player.stats.map(function (stat) {
            if (stat.season === CURRENT_SEASON) {
              thestat = stat;
            }
          });
          let lastgame: Game = thestat.lastgame;
          let teamname = lastgame?.team.name;
          let increase: boolean = lastgame?.price_change > 0;
          let teamcolors: string[] = TeamsList[teamname];
          if (lastgame) {
            newrows.push({
              id: player.id,
              name: `${player.firstname} ${player.lastname}`,
              team: teamname,
              //three: lastgame.three,
              //five: playerstats.five,
              priceincrease: increase,
              wickets: lastgame.wickets,
              runs: lastgame.runs,
              dotballs: lastgame.dotballs,
              avgpts: playerstats.avgpts
                ? playerstats.avgpts
                : player.stats[0].avgpts,
              teamlogo: TeamLogos[player.stats[0].last5Games[0]?.team?.name],
              teamcolors: teamcolors,
              teamname: teamname,
              batSR: player.batStrikeStat.avgSR,
              bwlSR: player.bwlStrikeStat.avgSR,
              pricechange: lastgame.price_change,
              lastgame: lastgame,
              ...lastgame,
              ...playerstats,
            });
          }
        }
      }
    });
    setRows(newrows);
  };

  return (
    <PageContainer>
      <Loading isLoading={isloading === "loading"} setDone={setDone} />
      <Header />
      <MyTransition location="/home" inProp={animate}>
        <MyContainer maxWidth="xl">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              columnGap: "1rem",
              rowGap: "1rem",
            }}
          >
            <Paper
              elevation={5}
              style={{
                width: "100%",
                padding: "0.5rem",
                marginBottom: "0.5rem",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  columnGap: "0.5rem",
                  alignItems: "center",
                }}
              >
                {PositonsArray.map(function (positionItem) {
                  if (positionname === positionItem.position) {
                    return (
                      <positionItem.icon
                        style={{ width: 48, height: 48, color: "#21ace1" }}
                      />
                    );
                  }
                })}
                <h3>{PositionStrings[positionname]}</h3>
              </div>
              <div style={{ display: "flex", columnGap: "1rem" }}>
                {PositonsArray.map(function (positionItem) {
                  if (positionname !== positionItem.position) {
                    return (
                      <RoundedCTA
                        Icon={
                          <positionItem.icon
                            style={{ width: 48, height: 48, color: "#21ace1" }}
                          />
                        }
                        link={`/position/${positionItem.position}`}
                        text={positionItem.position}
                        newTab={false}
                      />
                    );
                  }
                })}
              </div>
            </Paper>
            <CarouselContainer
              title={""}
              description={""}
              icon={""}
              hideTop={true}
            >
              {featuredPlayers.map(function (featuredPlayer) {
                return (
                  <FeaturePlayerCard
                    player={featuredPlayer}
                    rightStats={[
                      {
                        label: "Total Pts (2021-22)",
                        valueField: (
                          <h2 style={{ marginBottom: "0", marginTop: 0 }}>
                            {featuredPlayer.stats[0]?.lastSeasonTotalPoints}
                          </h2>
                        ),
                      },
                      {
                        label: "AVG Pts (2021-22)",
                        valueField: (
                          <h2 style={{ marginBottom: "0", marginTop: 0 }}>
                            {featuredPlayer.stats[0].lastSeasonAVGPoints?.toFixed(
                              2
                            )}
                          </h2>
                        ),
                      },
                      {
                        label: "Price",
                        valueField: (
                          <h2 style={{ marginBottom: "0", marginTop: 0 }}>
                            {featuredPlayer.stats[0]?.lastgame?.price?.toLocaleString(
                              "en-US",
                              {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              }
                            )}
                          </h2>
                        ),
                      },
                    ]}
                  />
                );
              })}
            </CarouselContainer>
            <div>
              <SinglePositionPlayers
                players={players}
                positionname={positionname}
              />
              {/* <PlayerCardsContainer players={players} hideposition={true} positionname={positionname}/> */}
            </div>

            <PlayerDataGrid
              height={"90vh"}
              rows={rows}
              columns={selectedColumns}
              onCellClick={onCellClick}
            />
            <AdsenseAdd />
          </div>
        </MyContainer>
      </MyTransition>
    </PageContainer>
  );
};

export default SinglePosition;
